import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { ClaimControllerApi } from "../../../services";
import { getConfigObject, getXtenantId } from "../../../utils/utils";

export function useGetClaimsByUuids(claimUuids: string[]) {
  return useQuery({
    queryKey: ["get-claims-by-uuids", claimUuids],
    enabled: claimUuids.length > 0,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const response = await new ClaimControllerApi(
        getConfigObject()
      ).getClaimsByUuids(claimUuids, getXtenantId());
      return response?.data;
    },
  });
}

export function useFetchClaimsByUuids() {
  return useCallback(async (claimUuids: string[]) => {
    const response = await new ClaimControllerApi(
      getConfigObject()
    ).getClaimsByUuids(claimUuids, getXtenantId());
    return response?.data;
  }, []);
}
